<template>
  <div>
    <h3 style="margin-bottom: 0;">Experience
      <span v-if="editAccess" style="float: right; cursor: pointer;" @click="showExperienceModal()">+</span>
    </h3>
    <small v-if="experiences.length < 3 && editAccess">Please list at least 3 previous childcare experiences. This is very important, it will make up your digital profile/resume that families see!</small>
    <hr>
    <div v-for="experience in experiences" :key="experience.id">
      <!-- {{ experiences }} -->
      <h5 style="font-weight: 600;">{{ experience.title }}<img v-if="editAccess" src="../../../assets/img/icons/edit_icon_simple.svg" alt="" width="16px" style="float: right; cursor: pointer;" @click="showExperienceModal(experience)"></h5>
      <p v-if="experience.start_date && experience.end_date && !experience.current_role">{{ monthsShort[(new Date(experience.start_date)).getMonth()] }} {{ (new Date(experience.start_date)).getFullYear() }} - {{ monthsShort[(new Date(experience.end_date)).getMonth()] }} {{ (new Date(experience.end_date)).getFullYear() }}</p>
      <p v-if="experience.current_role"><span v-if="experience.start_date">{{ monthsShort[(new Date(experience.start_date)).getMonth()] }} {{ (new Date(experience.start_date)).getFullYear() }} - </span>Present</p>
      <small style="font-weight: 600;" v-if="experience.city || experience.country">{{ experience.city }}, {{ experience.country }}</small>
      <!-- <p style="margin-top: 10px;">{{ experience.note }}</p> -->
      <hr style="margin-bottom: 0;">
      <div class="row">
        <div class="col-lg-6 mb-4">
          <!-- <label v-if="reference.text1">Number of Children Cared for</label>
          <p>{{ reference.text1 }}</p>
          <label v-if="reference.text2">Ages of Children</label>
          <p>{{ reference.text2 }}</p>
          <label v-if="reference.text3">Years Worked With Them</label>
          <p>{{ reference.text3 }}</p>
          <label v-if="reference.text4">How Frequently I Worked For Them</label>
          <p>{{ reference.text4 }}</p> -->
          <label v-if="experience.note">Expectations: list of expectations I had while working with this family</label>
          <p>{{ experience.note }}</p>
        </div>
        <div class="col-lg-6">
          <!-- <label v-if="reference.relationship">Relationship</label>
          <p>{{ reference.relationship }}</p>
          <label v-if="reference.phone">Mobile Phone</label>
          <p>{{ reference.phone }}</p>
          <label v-if="reference.phone2">Other Phone</label>
          <p>{{ reference.phone2 }}</p>
          <label v-if="reference.email">Email</label>
          <p>{{ reference.email }}</p> -->
          <label v-if="experience.text1">Number of Children Cared for</label>
          <p>{{ experience.text1 }}</p>
          <label v-if="experience.text2">Ages of Children</label>
          <p>{{ experience.text2 }}</p>
          <label v-if="experience.text3">Years Worked With Them</label>
          <p>{{ experience.text3 }}</p>
          <label v-if="experience.text4">How Frequently I Worked For Them</label>
          <p>{{ experience.text4 }}</p>
        </div>
      </div>
      <hr>
    </div>

    <!-- ------- EXPERIENCE MODAL ------- -->
    <modal name="experience-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h3 v-if="!experience.id">Add Experience</h3>
        <h3 v-if="experience.id">Edit Experience - {{ experience.title }}</h3>
        <hr>
        <div class="row">
          <div class="col-lg-6 px-4">
            <label>Position</label>
            <input type="text" class="form-control" v-model="title">
            <!-- <label>Company</label> -->
            <!-- <input type="text" class="form-control" v-model="company"> -->
            <div class="row">
              <!-- <div class="col-lg-6">
                <label>Employment Type</label>
                <select class="form-control" v-model="employmentType">
                  <option v-for="(type, index) in employmentTypes" :key="'employmentType'+index">{{ type }}</option>
                </select>
              </div> -->
              <div class="col-lg-6">
                <label>Currently in this role?</label>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" :value="true" v-model="currentRole">
                  <label style="margin-top: 1px;" class="form-check-label">
                    Yes
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <label>Start Date</label>
                <!-- <datepicker class="form-control" placeholder="" v-model="startDate" style="padding: .37rem .75rem; line-height: 1;"></datepicker> -->
                <div class="input-group">
                  <!-- <input type="text" placeholder="MM" class="form-control" v-model="startMonth"> -->
                  <select class="form-control" v-model="startMonth">
                    <option v-for="(month, index) in monthsNumeric" :key="'experienceStartMonth'+index">{{ month }}</option>
                  </select>
                  <input type="text" placeholder="YYYY" class="form-control" v-model="startYear">
                </div>
              </div>
              <div class="col-lg-6">
                <label>End Date</label>
                <div class="input-group" v-if="!currentRole">
                  <select class="form-control" v-model="endMonth">
                    <option v-for="(month, index) in monthsNumeric" :key="'experienceStartMonth'+index">{{ month }}</option>
                  </select>
                  <input type="text" placeholder="YYYY" class="form-control" v-model="endYear">
                </div>
                <p class="mt-1" v-if="currentRole">Present</p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <label>City</label>
                <input type="text" class="form-control" v-model="city">
              </div>
              <div class="col-lg-6">
                <label>Country</label>
                <!-- <label>State</label> -->
                <select class="form-control" v-model="country">
                  <option v-for="(country, index) in $store.getters.countries" :key="'countrySelection'+index">{{ country }}</option>
                  <!-- <option v-for="(state, index) in states" :key="'countrySelection'+index">{{ state }}</option> -->
                </select>
              </div>
            </div>

          </div>
          <div class="col-lg-6 px-4">
            <label>Number of Children Cared for*</label>
            <input type="text" class="form-control" v-model="numChildren">
            <label>Ages of Children When Hired*</label>
            <input type="text" class="form-control" v-model="ageChildren">
            <label>Specific Number of Years Worked With Them*</label>
            <small style="display: block;" class="mb-1">Ex. 3 years, 2012-2015</small>
            <input type="text" class="form-control" v-model="years">
            <label>How Frequently Did You Work For Them?*</label>
            <small style="display: block;" class="mb-1">Ex. Casual Babysitting 1-2x/month, Part-time Nanny 3 days/week</small>
            <input type="text" class="form-control" v-model="frequency">
            <label for="">Expectations: list of expectations you had while working with this family</label>
            <textarea class="form-control" style="" rows="5" v-model="description" placeholder=""></textarea>
          </div>
        </div>

        <hr>
        <div>
          <button class="mylisting-button secondary-button" @click="hideExperienceModal()">Cancel</button>
          <button v-if="experience.id" class="mylisting-button danger-button" @click="showDeleteExperienceModal()" style="">Delete</button>
          <button v-if="!experience.id" class="mylisting-button dark-button" @click="postExperience()" style="float: right;">Save</button>
          <button v-if="experience.id" class="mylisting-button dark-button" @click="updateExperience(experience)" style="float: right;">Save</button>
        </div>

        <!-- <button v-else class="mylisting-button dark-button" @click="unpublish()">Unpublish</button> -->
      </div>
    </modal>

    <modal name="delete-experience-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Are you sure you want to delete this experience?</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('delete-experience-modal')">Cancel</button>
        <button v-if="experience.id" class="mylisting-button danger-button" @click="deleteExperience(experience)" style="float: right;">Delete</button>
      </div>
    </modal>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['user'],
  data() {
    return {
      experiences: [],
      experience: {},
      title: '',
      employmentType: '',
      employmentTypes: [],
      company: '',
      months: [],
      monthsNumeric: [],
      monthsShort: [],
      startDate: null,
      startMonth: null,
      startYear: null,
      endDate: null,
      endMonth: null,
      endYear: null,
      city: '',
      country: '',
      countries: [],
      states: [],
      description: '',
      currentRole: false,

      numChildren: '',
      ageChildren: '',
      years: '',
      frequency: '',
    }
  },
  computed: {
    editAccess() {
      if (this.user.id == this.$store.getters.userID || this.$store.getters.isAgent === true) {
        return true
      } else {
        return false
      }
    },
    viewOnlyAccess() {
      if (this.$store.getters.isEmployer === true) {
        return true
      } else {
        return false
      }
    },
    adminOrEmployer() {
      if (this.$store.getters.isAgent === true || this.$store.getters.isEmployer === true) {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    this.getExperiences()

    this.months = this.$store.getters.months
    // https://stackoverflow.com/questions/19590865/from-an-array-of-objects-extract-value-of-a-property-as-array
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map
    this.monthsNumeric = this.months.map(month => month.number)
    this.monthsShort = this.months.map(month => month.short)
  },
  methods: {
    getExperiences() {
      axios.get(`/api/experiences/?user=${this.user.id}`)
        .then(res => {
          this.experiences = res.data
          this.experiences = this.experiences.sort((a, b) => (a.id > b.id) ? 1 : -1)
        })
        .catch(error => {
          console.log(error)
        })
    },
    showExperienceModal(experience) {
      if (experience) {
        this.experience = experience
        this.title = experience.title
        this.employmentType = experience.employment_type
        this.company = experience.company_name
        this.city = experience.city
        this.country = experience.country
        this.description = experience.note
        this.currentRole = experience.current_role
        this.startDate = experience.start_date
        this.endDate = experience.end_date

        if (experience.start_date) {
          // https://www.w3schools.com/jsref/jsref_split.asp
          this.startYear = experience.start_date.split('-')[0]
          this.startMonth = experience.start_date.split('-')[1]
        }
        if (experience.end_date) {
          // https://www.w3schools.com/jsref/jsref_split.asp
          this.endYear = experience.end_date.split('-')[0]
          this.endMonth = experience.end_date.split('-')[1]
        }

        this.numChildren = experience.text1
        this.ageChildren = experience.text2
        this.years = experience.text3
        this.frequency = experience.text4
      }
      else {
        this.experience = {}
        this.title = ''
        this.employmentType = ''
        this.company = ''
        this.startDate = null
        this.endDate = null
        this.city = ''
        this.country = 'United States'
        this.description = ''
        this.currentRole = false

        this.numChildren = ''
        this.ageChildren = ''
        this.years = ''
        this.frequency = ''
      }
      this.$modal.show('experience-modal')
    },
    hideExperienceModal() {
      this.$modal.hide('experience-modal')
    },
    postExperience() {
      if (this.startMonth && this.startYear) {
        this.startDate = this.startYear + '-' + this.startMonth + '-01'
      }
      if (this.endMonth && this.endYear && !this.currentRole) {
        this.endDate = this.endYear + '-' + this.endMonth + '-01'
      }

      axios.post('/api/experiences/', {
        user: this.user.id,
        title: this.title,
        company_name: this.company,
        employment_type: this.employmentType,
        start_date: this.startDate,
        end_date: this.endDate,
        city: this.city,
        country: this.country,
        note: this.description,
        current_role: this.currentRole,

        text1: this.numChildren,
        text2: this.ageChildren,
        text3: this.years,
        text4: this.frequency,

        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID,
      })
        .then(res => {
          console.log(res)
          this.hideExperienceModal()
          this.getExperiences()
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateExperience(experience) {
      if (this.startMonth && this.startYear) {
        this.startDate = this.startYear + '-' + this.startMonth + '-01'
      }
      if (this.endMonth && this.endYear && !this.currentRole) {
        this.endDate = this.endYear + '-' + this.endMonth + '-01'
      }

      axios.patch('/api/experiences/'+experience.id.toString()+'/', {
        title: this.title,
        // company_name: this.company,
        employment_type: this.employmentType,
        start_date: this.startDate,
        end_date: this.endDate,
        city: this.city,
        country: this.country,
        note: this.description,
        current_role: this.currentRole,

        text1: this.numChildren,
        text2: this.ageChildren,
        text3: this.years,
        text4: this.frequency,
      })
        .then(res => {
          console.log(res)
          this.hideExperienceModal()
          this.getExperiences()
        })
        .catch(error => {
          console.log(error)
        })
    },
    showDeleteExperienceModal() {
      this.$modal.show('delete-experience-modal')
    },
    deleteExperience(experience) {
      axios.delete('/api/experiences/'+experience.id.toString()+'/')
        .then(res => {
          console.log(res)
          this.getExperiences()
          this.hideExperienceModal()
          this.$modal.hide('delete-experience-modal')
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/candidates/profile/Experiences.vue